import React, { useState, useRef, useEffect } from 'react';
import styles from './PrintInvoiceModal.module.css';
import myAxios from '../AxiosUrl';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useReactToPrint } from 'react-to-print';
import Moment from 'moment';
import { orderDeliveryAmount } from '../Helper/deliveryAmount';

function PrintInvoiceModal({ setOpenPrint, printModalData, setRefresh, setOpenStickerModal, setStickerModalData }) {
    const [loading1, setLoading1] = useState(false);
    const [store, setStore] = useState([]);
    const [tp, setTp] = useState(0);
    const [Dhaka, setDhaka] = useState(null);
    const [Outside, setOutside] = useState(null);
    const [isStoreLoaded, setIsStoreLoaded] = useState(false);
    const data = printModalData;
    const uid = localStorage.getItem('id');

    let PriceAfterAdvance;
    if (data?.advance && data?.discount) {
        let ad = parseInt(data.advance) + parseInt(data.discount);
        PriceAfterAdvance = data.totalPrice - ad;
    } else if (data?.advance) {
        PriceAfterAdvance = data.totalPrice - parseInt(data.advance);
    } else if (data?.discount) {
        PriceAfterAdvance = data.totalPrice - parseInt(data.discount);
    } else {
        PriceAfterAdvance = data?.totalPrice || 0;
    }

    const invoiceRef = useRef(null);

    const handlePrintInvoice = useReactToPrint({
        content: () => invoiceRef.current,
        documentTitle: 'Invoice-' + (data?.InvoiceId || 'order'),
        onAfterPrint: () => {
            toast.success('Invoice printed!');
            setLoading1(false);
        },
        onBeforePrint: () => {
            if (!isStoreLoaded) {
                toast.error('Please wait, loading store data...');
                return Promise.reject();
            }
        },
    });

    useEffect(() => {
        if (!uid) return;
        setIsStoreLoaded(false);
        myAxios.get('get-domain-new/' + uid)
            .then((res) => {
                console.log("handlePrintInvoice",res.data )
                if (res.data) {
                    setStore([res.data]); // Wrap in array for backward compatibility
                    // Parse delivery charges as integers
                    const dhakaCharge = parseInt(res.data.Dhaka) || 0;
                    const outsideCharge = parseInt(res.data.Outside) || 0;
                    setDhaka(dhakaCharge);
                    setOutside(outsideCharge);
                    setIsStoreLoaded(true);
                }
            })
            .catch((err) => {
                console.error('Error:', err);
                setDhaka(0);
                setOutside(0);
                setIsStoreLoaded(true); // Still allow print even if store data fails
            });
    }, [uid]);

    // Calculate total whenever delivery charge or price changes
    useEffect(() => {
        // Only calculate when delivery charges are loaded
        if (Dhaka === null || Outside === null) return;

        console.log('Delivery Charge Debug:', {
            deliveryCharge: data?.deliveryCharge,
            Dhaka,
            Outside,
            PriceAfterAdvance
        });

        setTp(orderDeliveryAmount(data, Dhaka, Outside) + parseInt(PriceAfterAdvance));
    }, [Dhaka, Outside, PriceAfterAdvance, data?.deliveryCharge, data?.deliveryAmount]);

    return (
        <div className={styles.modernModalOverlay} onClick={() => setOpenPrint(false)}>
            <ToastContainer position="top-right" autoClose={2000} />
            <div className={styles.modernModalBox} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modernHeader}>
                    <div className={styles.headerContent}>
                        <div className={styles.headerIcon}>
                            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M6 9V2h12v7M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>
                                <path d="M6 14h12v8H6z"/>
                            </svg>
                        </div>
                        <div>
                            <h2 className={styles.headerTitle}>Print Order</h2>
                            <p className={styles.headerSubtitle}>Invoice #{data?.InvoiceId || 'N/A'}</p>
                        </div>
                    </div>
                    <button className={styles.modernCloseBtn} onClick={() => setOpenPrint(false)}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <line x1="18" y1="6" x2="6" y2="18"/>
                            <line x1="6" y1="6" x2="18" y2="18"/>
                        </svg>
                    </button>
                </div>
                <div className={styles.modernActions}>
                    <button className={styles.modernBtn + ' ' + styles.stickerButton} onClick={() => {
                        setStickerModalData({
                            InvoiceId: data?.InvoiceId,
                            StoreName: store[0]?.store,
                            Name: data?.cName,
                            Mobile: data?.cMobile,
                            Address: data?.address,
                            TotalPrice: tp,
                            PaymentType: data?.PaymentType || 'cod',
                            Products: data?.orderData,
                        });
                        setOpenPrint(false);
                        setOpenStickerModal(true);
                    }}>
                        <svg className={styles.btnIcon} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="2" y="3" width="20" height="14" rx="2"/>
                            <path d="M8 21h8M12 17v4"/>
                        </svg>
                        <span>Print Sticker</span>
                    </button>
                    <button className={styles.modernBtn + ' ' + styles.invoiceButton} onClick={() => {
                        if (!isStoreLoaded) {
                            toast.warning('Please wait, loading store data...');
                            return;
                        }
                        setLoading1(true);
                        handlePrintInvoice();
                    }} disabled={loading1 || !isStoreLoaded}>
                        <svg className={styles.btnIcon} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                            <polyline points="14 2 14 8 20 8"/>
                            <line x1="16" y1="13" x2="8" y2="13"/>
                            <line x1="16" y1="17" x2="8" y2="17"/>
                        </svg>
                        <span>{!isStoreLoaded ? 'Loading...' : loading1 ? 'Printing...' : 'Print Invoice'}</span>
                    </button>
                    <button className={styles.modernBtn + ' ' + styles.cancelButton} onClick={() => setOpenPrint(false)}>
                        <svg className={styles.btnIcon} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <line x1="18" y1="6" x2="6" y2="18"/>
                            <line x1="6" y1="6" x2="18" y2="18"/>
                        </svg>
                        <span>Cancel</span>
                    </button>
                </div>
                <div className={styles.modernPreview}>
                    <div className={styles.previewHeader}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                            <circle cx="12" cy="12" r="3"/>
                        </svg>
                        <span>Invoice Preview</span>
                    </div>
                    <div ref={invoiceRef} className={styles.invoiceContent}>
                        <div className={styles.invoiceTop}>
                            <div className={styles.invoiceBrand}>
                                {store[0]?.logo && <img src={store[0].logo} alt="Logo" className={styles.brandLogo} />}
                                <div>
                                    <h1 className={styles.invoiceHeading}>INVOICE</h1>
                                    <p className={styles.storeName}>{store[0]?.store}</p>
                                </div>
                            </div>
                            <div className={styles.invoiceDetails}>
                                <p><strong>Date:</strong> {Moment(data?.updateDate).format('DD-MM-YYYY')}</p>
                                <p><strong>Invoice:</strong> {data?.InvoiceId}</p>
                            </div>
                        </div>
                        <div className={styles.invoiceParties}>
                            <div className={styles.party}>
                                <h3>From</h3>
                                <p><strong>Store:</strong> {store[0]?.store}</p>
                                <p><strong>Domain:</strong> {store[0]?.domain}</p>
                                <p><strong>Mobile:</strong> {store[0]?.number}</p>
                            </div>
                            <div className={styles.party}>
                                <h3>To</h3>
                                <p><strong>Name:</strong> {data?.cName}</p>
                                <p><strong>Mobile:</strong> {data?.cMobile}</p>
                                <p><strong>Address:</strong> {data?.address}</p>
                            </div>
                        </div>
                        <table className={styles.productTable}>
                            <thead><tr><th>Product</th><th>Image</th><th>SKU</th><th>Color</th><th>Size</th><th>Price</th><th>Qty</th><th>Amount</th></tr></thead>
                            <tbody>
                                {data?.orderData?.map((item, i) => (
                                    <tr key={i}>
                                        <td>{item.title}</td>
                                        <td><img src={item.image} alt="" width="40" height="40" /></td>
                                        <td>{item.pCode}</td>
                                        <td>{item.colorName}</td>
                                        <td>{item.Size || 'N/A'}</td>
                                        <td>{item.price}</td>
                                        <td>{item.quantity}</td>
                                        <td>{item.quantity * item.price}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className={styles.summarySection}>
                            <div className={styles.summaryRow}><span>Subtotal:</span><span>{data?.totalPrice}</span></div>
                            <div className={styles.summaryRow}><span>Discount:</span><span>- {data?.discount || 0}</span></div>
                            <div className={styles.summaryRow}><span>Advance:</span><span>- {data?.advance || 0}</span></div>
                            <div className={styles.summaryRow}><span>Delivery:</span><span>+ {orderDeliveryAmount(data, Dhaka, Outside)}</span></div>
                            <div className={styles.summaryRow + ' ' + styles.totalRow}><span>Total:</span><span>{tp}</span></div>
                            <div className={styles.paymentType}><span>Payment: </span><span className={styles.codBadge}>CASH ON DELIVERY</span></div>
                            {data?.OrderNote && <div className={styles.noteBox}><strong>Note:</strong> {data.OrderNote}</div>}
                        </div>
                        <div className={styles.invoiceFooter}><p>Thank you for your business!</p></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PrintInvoiceModal;
